import ScaledImage from '../components/ScaledImage'
import React from 'react'
import { useInstance } from './instance.selectors'

export const Logo = () => {
    const instance = useInstance()
    const uuid = instance?.value?.smallLogo?.uuid
    if (!uuid) {
        return null
    }
    return (
        <ScaledImage
            instanceNameOverride={instance?.value?.instanceName}
            uuid={uuid}
            w={32}
            h={32}
            crop={false}
        />
    )
}